export const months: string[] = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export const filterPeriodicEnum = ['Daily', 'Weekly', 'Monthly', 'Yearly'];

export const searchTypingTimeout = 500;

export const STEP_LABELS = [
    'Container Booking',
    'Gate In Smelter',
    'Start Loading',
    'Finished Loading',
    'Gate Out Smelter',
    'Port Gate In',
    'CY Check In',
    'ATD POL',
    'ATA POD'
];

// Define milestone to step index mapping
export const MILESTONE_TO_STEP_INDEX = {
    'Container Booking': 0,
    'Container Booked': 0,
    'Gate In Smelter': 1,
    'Start Loading': 2,
    'Finished Loading': 3,
    'Gate Out Smelter': 4,
    'Port Gate In': 5,
    'CY Check In': 6,
    'ATD POL': 7,
    'ATA POD': 8,
    // Add any other milestone mappings that might come from the API
};